if (!customElements.get('age-gate')) {
  class AgeGate extends HTMLElement {
    constructor() {
      super();

      this.ageGateInput = this.querySelector('.AgeGate__Input');
      this.cartDrawer = this.closest('cart-drawer');
      this.cartCheckoutBtn = this.cartDrawer.querySelector('.CartDrawer__Checkout');
      this.alertMessage = this.cartDrawer.querySelector('.CartDrawer__MinBottlesMessage')
      this.ageGateInput.addEventListener('change', this.onChange.bind(this));
      this.ageGateChecked = sessionStorage.getItem('ageGateChecked');

      if (this.ageGateChecked) {
        this.ageGateInput.checked = true;
        this.onChange(false);
      }
    }

    onChange(setStorage = true) {
      if (setStorage) {
        sessionStorage.setItem('ageGateChecked', 'true');
      }

      if (this.ageGateInput.checked && !this.alertMessage) {
        this.cartCheckoutBtn.removeAttribute('disabled');
      } else {
        this.cartCheckoutBtn.setAttribute('disabled', 'disabled')
      }
    }
  }

  customElements.define('age-gate', AgeGate);
}